import { NARROW_SCREEN_PANEL_Z_INDEX } from 'components/MapControlsPanel/narrowScreenPanelZIndex'

// ties with the details panel, which comes later in the page and so stays on top
export const PHONE_MAP_CARD_Z_INDEX = NARROW_SCREEN_PANEL_Z_INDEX + 1
